import { Toolbar } from "@mui/x-data-grid-pro";
import { ExportMenu } from "../../../../modules/generic/components/export-menu";

import type { FC } from "react";

export const ExportToolbar: FC = () => (
  <Toolbar>
    <ExportMenu hideText={true} />
  </Toolbar>
);
